import { Component, OnInit, Input } from '@angular/core';
import { _ } from 'underscore';
import {
  trigger,
  state,
  style,
  animate,
  transition,
  group
} from '@angular/animations';
import { CommercialService } from '../../commercial.service';

@Component({
  selector: 'app-cq12',
  templateUrl: './cq12.component.html',
  styleUrls: ['./cq12.component.css', '../commercial-questionnaire.component.css'],
  animations: [
    trigger('flyInOut', [
      state('in', style({
        transform: 'translateX(0)', opacity: 1
      })),
      transition('void => *', [
        style({transform: 'translateX(100px)', opacity: 0 }),
        group([
          animate('0.4s 0.1s ease', style({
            transform: 'translateX(0)',
          })),
          animate('0.4s ease', style({
            opacity: 1
          }))
        ])
      ]),
      transition('* => void', [
        group([
          animate('0.4s ease', style({
            transform: 'translateX(50px)',
          })),
          animate('0.4s 0.2s ease', style({
            opacity: 0
          }))
        ])
      ])
    ])
  ]
})
export class Cq12Component implements OnInit {

  @Input() data: any;
  question;
  questions;
  user_bot = false;
  showbutton = true;
  userResponses = [];
  questionObj;
  deviceWidth;
  project1_id;
  project2_id;
  project3_id;
  project4_id;
  timer;
  isChecked;
  project;
  hgProject;
  location_projects = [];
  showTyping =  false;
  time = 3000;

  constructor(private commercialService: CommercialService) {
    this.questions = this.commercialService.getQues();
    this.deviceWidth = this.commercialService.deviceWidth;
    this.userResponses = this.commercialService.userResponse.userResponses;
    this.hgProject = {
      project1: false,
      project2: false,
      project3: false,
      project4: false
    };
  }

  goNext() {
    if (this.timer) {
      clearTimeout(this.timer);
    }
    if (this.deviceWidth < 768) {
      this.timer = setTimeout(() => {
        this.next();
      }, 1000);
    }
  }

  typingNext() {
    clearTimeout(this.timer);
    if (this.deviceWidth < 768) {
      this.commercialService.unSelectService({'currentId': this.data});
      this.showTyping = true;
      this.timer = setTimeout(() => {
        this.showTyping = false;
        this.next();
      }, this.time);
    }
  }

  ngOnInit() {
    this.commercialService.currentId = this.data;
    if (this.deviceWidth < 768) {
      this.project1_id = document.getElementById('project1_mob');
      this.project2_id = document.getElementById('project2_mob');
      this.project3_id = document.getElementById('project3_mob');
      this.project4_id = document.getElementById('project4_mob');
    } else {
      this.project1_id = document.getElementById('project1');
      this.project2_id = document.getElementById('project2');
      this.project3_id = document.getElementById('project3');
      this.project4_id = document.getElementById('project4');
    }
    for (let i = 0; i < this.questions.length; i++) {
      if (this.questions[i]._id === this.data) {
        this.question = this.questions[i].com_question;
        this.questionObj = this.questions[i];
      }
    }
    this.userResponses = this.commercialService.userResponse.userResponses;
    if (this.userResponses.length > 0 && !_.isEmpty(this.questionObj)) {
      const obj = _.findWhere(this.userResponses, { 'com_question_id': this.questionObj._id });
      if (!_.isEmpty(obj)) {
        this.location_projects = obj.fieldValue;
        if (!this.commercialService.addAddress && !_.isEmpty(this.location_projects)) {
          let index;
          if (this.commercialService.serialNumber !== null) {
            index = this.commercialService.serialNumber;
          } else if (this.commercialService.serialNumber === null) {
            index = 0;
          }
          if (!_.isEmpty(this.location_projects[index])) {
            this.project = this.location_projects[index].value;
            this.isChecked = true;
            if (!_.isEmpty(this.project)) {
              if (this.project === 'New construction') {
                this.hgProject = {
                  project1: true,
                  project2: false,
                  project3: false,
                  project4: false
                };
                this.project1_id.parentElement.classList.add('active-select');
              } else if (this.project === 'Building renovation') {
                this.hgProject = {
                  project1: false,
                  project2: true,
                  project3: false,
                  project4: false
                };
                this.project2_id.parentElement.classList.add('active-select');
              } else if (this.project === 'New location') {
                this.hgProject = {
                  project1: false,
                  project2: false,
                  project3: true,
                  project4: false
                };
                this.project3_id.parentElement.classList.add('active-select');
              } else if (this.project === 'Change of ownership') {
                this.hgProject = {
                  project1: false,
                  project2: false,
                  project3: false,
                  project4: true
                };
                this.project4_id.parentElement.classList.add('active-select');
              }
              this.user_bot = true;
              if (this.deviceWidth < 768) {
                if (this.commercialService.modifyAddress) {
                  this.typingNext();
                } else {
                  this.goNext();
                }
              }
            }
          }
        }
      }
    }

    if(!this.hgProject.project1 && !this.hgProject.project2 && !this.hgProject.project3 && !this.hgProject.project4 )
    {
      this.showbutton = false;
    }
  }

  getProject(event) {
    this.project = event.target.value;
    this.isChecked = event.target.checked;
    if (this.isChecked === true) {
      if (this.deviceWidth < 768) {
        // // console.log.log(this.deviceWidth);
        this.commercialService.unSelectService({'currentId': this.data});
      }
      if (!_.isEmpty(this.project)) {
        this.user_bot = true;
        if (this.project === 'New construction') {
          this.hgProject = {
            project1: true,
            project2: false,
            project3: false,
            project4: false
          };
          if (_.contains(this.project2_id.parentElement.classList, 'active-select')) {
            this.project2_id.parentElement.classList.remove('active-select');
          }
          if (_.contains(this.project3_id.parentElement.classList, 'active-select')) {
            this.project3_id.parentElement.classList.remove('active-select');
          }
          if (_.contains(this.project4_id.parentElement.classList, 'active-select')) {
            this.project4_id.parentElement.classList.remove('active-select');
          }
          this.project1_id.parentElement.classList.add('active-select');
        } else if (this.project === 'Building renovation') {
          this.hgProject = {
            project1: false,
            project2: true,
            project3: false,
            project4: false
          };
          this.project2_id.parentElement.classList.add('active-select');
          if (_.contains(this.project1_id.parentElement.classList, 'active-select')) {
            this.project1_id.parentElement.classList.remove('active-select');
          }
          if (_.contains(this.project3_id.parentElement.classList, 'active-select')) {
            this.project3_id.parentElement.classList.remove('active-select');
          }
          if (_.contains(this.project4_id.parentElement.classList, 'active-select')) {
            this.project4_id.parentElement.classList.remove('active-select');
          }
        } else if (this.project === 'New location') {
          this.hgProject = {
            project1: false,
            project2: false,
            project3: true,
            project4: false
          };
          this.project3_id.parentElement.classList.add('active-select');
          if (_.contains(this.project1_id.parentElement.classList, 'active-select')) {
            this.project1_id.parentElement.classList.remove('active-select');
          }
          if (_.contains(this.project2_id.parentElement.classList, 'active-select')) {
            this.project2_id.parentElement.classList.remove('active-select');
          }
          if (_.contains(this.project4_id.parentElement.classList, 'active-select')) {
            this.project4_id.parentElement.classList.remove('active-select');
          }
        } else if (this.project === 'Change of ownership') {
          this.hgProject = {
            project1: false,
            project2: false,
            project3: false,
            project4: true
          };
          this.project4_id.parentElement.classList.add('active-select');
          if (_.contains(this.project1_id.parentElement.classList, 'active-select')) {
            this.project1_id.parentElement.classList.remove('active-select');
          }
          if (_.contains(this.project3_id.parentElement.classList, 'active-select')) {
            this.project3_id.parentElement.classList.remove('active-select');
          }
          if (_.contains(this.project2_id.parentElement.classList, 'active-select')) {
            this.project2_id.parentElement.classList.remove('active-select');
          }
        }
        if (this.deviceWidth < 768) {
          this.goNext();
        }
      }
    } else {
      this.hgProject = {
        project1: false,
        project2: false,
        project3: false,
        project4: false
      };
      if (_.contains(this.project1_id.parentElement.classList, 'active-select')) {
        this.project1_id.parentElement.classList.remove('active-select');
      }
      if (_.contains(this.project3_id.parentElement.classList, 'active-select')) {
        this.project3_id.parentElement.classList.remove('active-select');
      }
      if (_.contains(this.project2_id.parentElement.classList, 'active-select')) {
        this.project2_id.parentElement.classList.remove('active-select');
      }
      if (_.contains(this.project4_id.parentElement.classList, 'active-select')) {
        this.project4_id.parentElement.classList.remove('active-select');
      }
      this.project = '';
      if (this.deviceWidth < 768) {
        this.commercialService.unSelectService({'currentId': this.data});
      }
      this.user_bot = false;
    }
    this.save();

    if (this.isChecked === true)
    {
      if (this.deviceWidth < 768) {
       
      }else
      {
        if(!this.showbutton)
        {
          this.next();
        }
  
      }

    }
  }

  next() {
    if (_.isEmpty(this.project)) {
      if (this.deviceWidth < 768) {
        this.commercialService.unSelectService({'currentId': this.data});
      }
    } else {
      this.commercialService.messageService({ 'currentId': this.data });
    }
  }

  // This function is used for to save the data in DB
  save() {
    let index;
    if (this.commercialService.serialNumber === null) {
      index = this.location_projects.length;
    } else if (this.commercialService.serialNumber !== null) {
      index = this.commercialService.serialNumber;
    }
    this.location_projects[index] = { 'serialNo': index + 1, 'value': this.project };
    const Obj = {
      'com_question_id': this.data, 'fieldName': 'project', 'fieldValue': this.location_projects
    };
    this.commercialService.updateResponses(Obj);
  }

}
